// extracted by mini-css-extract-plugin
export default {"btnOn":"SwitchBtn_btnOn__W79b3","btnOff":"SwitchBtn_btnOff__pXMTx"};